import * as React from 'react';
import * as s from './PortfolioFilters.module.scss';
import { PortfolioContext } from '../../../../context/PortfolioContext';
import { PortfolioSelect } from '../PortfolioSelect';

export interface Props {}

interface PortfolioState {}

export class PortfolioFilters extends React.Component<Props, PortfolioState> {
  static contextType = PortfolioContext;

  render() {
    const { locations, responsibilities } = this.context;
    return (
      <div className={`row ${s.filtersWrapper}`}>
        <PortfolioSelect
          options={locations}
          type="location"
          className="mr-md-2"
        />
        <PortfolioSelect
          options={responsibilities}
          type="responsibility"
          className="ml-md-2"
        />
      </div>
    );
  }
}
